import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

/**
 * What the shell asks every `Page` to show under its header (phones: the sub-nav folded into a card, because the
 * library `AppShell` has no slot between the page header and the content).
 */
export const PageAsideContext = createContext<ReactNode>(null);

export function usePageAside(): ReactNode {
    return useContext(PageAsideContext);
}
